const OpenReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        ...action.data,
        userGroupList: action.userGroupList,
        loggedIn: true,
      };

    case "LOGOUT":
      return { ...state, loggedIn: false };
    case "CHANGE_HEADER":
      return {
        ...state,
        header: action.data,
      };
    case "CHANGE_TOGGLE":
      return {
        ...state,
        toggle: action.data,
      };

    case "SET_PUBLIC_DATA":
      return {
        ...state,
        ...action.data,
      };

    default:
      return state;
  }
};
export default OpenReducer;
